<template>
  <div class="mt-4">
    <div class="login-logo">
      <img src="/resources/logos/BS LOGO_LOGO PLATEADO.png" alt style="width:190px" />
    </div>
    <div class="login-box-body">
      <p class="login-box-msg">Password Recovery</p>

      <form
        action="../../index.html"
        method="post"
        class="form-element"
        @submit="onSubmit"
      >
        <div class="form-group has-feedback">
          <input
            type="text"
            class="form-control"
            placeholder="Please eneter your Username"
            v-model="model.username"
          />
          <span class="ion ion-email form-control-feedback"></span>
        </div>

        <div class="row">
          <div class="col-12 text-center">
            <button
              v-if="!loading"
              type="submit"
              class="btn btn-success btn-block margin-top-10"
            >
              RECOVER NOW
            </button>
            <button
              v-else
              type="submit"
              class="btn btn-success btn-block margin-top-10"
              disabled
            >
              Loading <i class="fa fa-circle-o-notch fa-spin"></i>
            </button>
          </div>
        </div>
      </form>
      <div class="margin-top-30 text-center">
        <p>
          Don't have an account?
          <router-link to="/register" class=" text-yellow hover-warning m-l-5 "
            >Sign Up</router-link
          >
        </p>
        <p>
          Want to sign in?
          <router-link to="/login" class=" text-yellow hover-warning m-l-5"
            >Log In</router-link
          >
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import router from "@/router";

export default {
  name: "login",
  data() {
    return {
      loading: false,
      model: {
        username: "",
        password: "",
      },
    };
  },

  methods: {
    onSubmit(evt) {
      this.loading = true;
      evt.preventDefault();
      this.$http
        .post("/api/v1/client/pass_recoveries", this.model)
        .then(() => {
          this.$toasted.show(
            "Please check your email to get your new password",
            {
              position: "top-right",
              duration: 5000,
              type: "success",
              closeOnSwipe: true,
            }
          );
          this.loading = false;
          this.model = {};
        })
        .catch((error) => {
          this.$toasted.show(error.response.data.status, {
            position: "top-right",
            theme: "toasted-primary",
            duration: 5000,
            type: "error",
            closeOnSwipe: true,
          });
          this.loading = false;
        });
    },

    storeLogin(data) {
      let action;
      let firstPage = "dashboard?auth=true";
      action = async () => {
        await localStorage.setItem("auth_token", data.auth_token);
        await localStorage.setItem("user", JSON.stringify(data.user));
        await router.push(firstPage);
      };
      action();
    },
  },
};
</script>
